import React from 'react'
import Tour from '../components/Tours/Tour'

const Tours = () => {
  return <Tour />
}

export default Tours
